import {
  Box,
  Flex,
  Icon,
  IconButton,
  Typography,
} from '@project44/manifest-ds';

interface ISidePanel {
  children: React.ReactNode;
  onClose: () => void;
  startIcon?: JSX.Element;
  title: string;
}

const styles = {
  root: {
    backgroundColor: 'white',
    borderRadius: '$small',
    boxShadow: '$medium',
    height: '100%',
    width: '645px',
  },
  header: {
    borderBottom: '1px solid $border-primary',
    padding: '9px $medium', // match table header
  },
};

function SidePanel({ children, onClose, startIcon, title }: ISidePanel) {
  return (
    <Box css={styles.root}>
      <Flex orientation="vertical" css={{ height: '100%' }}>
        <Flex align="center" justify="between" css={styles.header}>
          <Flex align="center" gap="small">
            {startIcon}
            <Typography variant="title">{title}</Typography>
          </Flex>
          <IconButton
            variant="tertiary"
            onPress={onClose}
            children={<Icon icon="close" />}
          />
        </Flex>
        {children}
      </Flex>
    </Box>
  );
}

export default SidePanel;
